import './styles/global.css';
import { registerRoot } from 'remotion';

// Components
import { RemotionRoot } from '@/App';

registerRoot(RemotionRoot);
